const arrowdownIcon = `
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Dashboard" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="DB-Dashboard" transform="translate(-503.000000, -1254.000000)" fill="#979797" fill-rule="nonzero">
            <g id="Latest-photos" transform="translate(316.000000, 1045.000000)">
                <g id="Photo" transform="translate(0.000000, 40.000000)">
                    <g id="Group-3" transform="translate(185.000000, 167.000000)">
                        <g id="data-download-1" transform="translate(0.000000, -0.000000)">
                            <g id="Line_Icons" transform="translate(2.000000, 2.000000)">
                                <g id="Group">
                                    <path d="M10,0.001 C4.486,0.001 0,4.486 0,10.001 C0,15.515 4.486,20.001 10,20.001 C15.514,20.001 20,15.515 20,10.001 C20,4.487 15.514,0.001 10,0.001 Z M10,18.001 C5.589,18.001 2,14.411 2,10.001 C2,5.589 5.589,2.001 10,2.001 C14.411,2.001 18,5.589 18,10.001 C18,14.412 14.411,18.001 10,18.001 Z" id="Shape"></path>
                                    <polygon id="Path" points="11 12.587 11 4.001 9 4.001 9 12.587 6.707 10.294 5.293 11.708 10 16.416 14.707 11.708 13.293 10.294"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`;

export default arrowdownIcon;
